export default __webpack_public_path__ + "static/media/logo.68193bc6.svg";